import { MonthPickerInput } from '@mantine/dates';
import classes from './MonthPickerInput.module.css';

export const MonthPickerInputConfig = MonthPickerInput.extend({
  classNames: {
    input: classes.input,
  },
});
